import React from "react";

function DoctorDashboardComponent() {

    const formatTime = (timestampStr) => {
  // Convert "13-06-2025 11:01:33" -> "2025-06-13T11:01:33"
  const [datePart, timePart] = timestampStr.split(" ");
  const [day, month, year] = datePart.split("-");
  const isoString = `${year}-${month}-${day}T${timePart}`;

  const date = new Date(isoString);

  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

  const attendanceInTime =
    JSON.parse(localStorage.getItem("userData") || "{}")?.todayAttendance
      ?.inTime ??
    JSON.parse(localStorage.getItem("attendance") || "{}")?.inTime ??
    null;

  const attendanceOutTime =
    JSON.parse(localStorage.getItem("userData") || "{}")?.todayAttendance
      ?.outTime ??
    JSON.parse(localStorage.getItem("attendance") || "{}")?.outTime ??
    null;

    console.log("Attendance In Time:", attendanceInTime);
    
  return (
    <>
      <div className="bg-gray-50 min-h-screen pb-6">
        {/* Top fixed header */}
        <div className="bg-white sticky top-0 shadow-sm z-10">
          <div className="p-4">
            <div className="flex justify-between items-center gap-2">
              {/* Attendance In Time */}
              <div className="flex flex-col items-center bg-blue-50 p-4 rounded-lg shadow-md">
                <span className="text-sm font-medium text-gray-700">
                  Attendance In
                </span>
                <p className="mt-2 text-xl font-semibold text-blue-600">
                  {attendanceInTime ? formatTime(attendanceInTime) : "--:--"}{" "}
                  {/* Format the time */}
                </p>
              </div>

              {/* Attendance Out Time */}
              <div className="flex flex-col items-center bg-green-50 p-4 rounded-lg shadow-md">
                <span className="text-sm font-medium text-gray-700">
                  Attendance Out
                </span>
                <p className="mt-2 text-xl font-semibold text-green-600">
                  {attendanceOutTime ? formatTime(attendanceOutTime) : "--:--"}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DoctorDashboardComponent;
